import type { UserPermission } from '@/shared/types/permissions';
import { hasPermission } from '@/shared/utils/permissions';
import type { RootState } from '@/store';
import { useSelector } from 'react-redux';

export const usePermissions = () => {
  const currentUser = useSelector((state: RootState) => state.users.currentUser);

  return {
    hasPermission: (permission: UserPermission) => hasPermission(currentUser, permission),
  };
};
